import { render, staticRenderFns } from "./AdminIneligibleStudents.vue?vue&type=template&id=0d10e856&scoped=true&"
import script from "./AdminIneligibleStudents.vue?vue&type=script&lang=js&"
export * from "./AdminIneligibleStudents.vue?vue&type=script&lang=js&"
import style0 from "./AdminIneligibleStudents.vue?vue&type=style&index=0&id=0d10e856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10e856",
  null
  
)

export default component.exports